import { axiosInstance } from '../api';

/**
 * Deletes a finding (study) by ID. Admin-only endpoint.
 */
export default function(studyId) {
    return axiosInstance.delete(`/api/study/${studyId}`);
}
